import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  BgSummaryrecordTable,
  BgIncomeTable,
  BgDeprecitionHistoryTable,
  BgFAMAssetTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { getTransactionCustom } from "../../../api/transaction-type";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));
export default function ExpenseReportCustom() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  useEffect(() => {
    if (user.token) {
      getTransactionCustomData();
    }
  }, [user.token]);
  async function getTransactionCustomData() {
    try {
      const { data } = await getTransactionCustom(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data[0]);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    }
  }
  console.log(rowData, "rowData");
  return (
    <>
      {/* {rowData?.map((el, i) => ( */}
        <Box className="viewDetilsBox" >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">GP TRANSACTION ID</p>
              <p className="tFormName">{rowData?.gp_transaction_id}</p>
            </Grid>

            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">BILLABLE ITEM COUNT</p>
              <p className="tFormName">{rowData?.billable_item_count}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">APPORVAL STATUS</p>
              <p className="tFormName">{rowData?.approval_status}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">CONCUR ID</p>
              <p className="tFormName">{rowData?.concur_id}</p>
            </Grid>
            
            {/* <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">
                OPENAIR EXPENSE APPROVER - SUPERVISOR
              </p>
              <p className="tFormName">
                {rowData?.openair_expense_approver_supervisor}
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        el.export_to_openair === "" ||
                        el.export_to_openair === "F"
                          ? false
                          : true
                      }
                    />
                  }
                  label="EXPORT TO OPENAIR (2)"
                />
              </FormGroup>
            </Grid> */}
          </Grid>
          <Tabs
          value={tabIndexRelatedRecord}
          onChange={(e, nv) => setTabIndexRelatedRecord(nv)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={`${classes.spacedTabs} tabs-sub-bkg`}
        >
          <Tab label="BG Summary Records" />
          <Tab label="FAM Expense/Income" />
          <Tab label="FAM Depreciation History" />
          <Tab label="FAM Asset" />
        </Tabs>

        <TabPanel value={tabIndexRelatedRecord} index={0}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>VIEW</InputLabel>
                <Select value="" label="VIEW">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>BG Summary Records</InputLabel>
                <Select value="" label="BG Summary Records">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ p: 1 }}>
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New BG Summary Records</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>

          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgSummaryrecordTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>

        <TabPanel value={tabIndexRelatedRecord} index={1}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>VIEW</InputLabel>
                <Select value="" label="VIEW">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>FAM Expense/Income</InputLabel>
                <Select value="" label="FAM Expense/Income">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ p: 1 }}>
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Expense/Income</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>

          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgIncomeTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>

        <TabPanel value={tabIndexRelatedRecord} index={2}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>VIEW</InputLabel>
                <Select value="" label="VIEW">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>FAM Depreciation History</InputLabel>
                <Select value="" label="FAM Depreciation History">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ p: 1 }}>
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Depreciation History</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>

          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgDeprecitionHistoryTable}
            refreshCounter={0}
          />
        </TabPanel>

        <TabPanel value={tabIndexRelatedRecord} index={3}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>VIEW</InputLabel>
                <Select value="" label="VIEW">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>FAM Asset</InputLabel>
                <Select value="" label="FAM Asset">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ p: 1 }}>
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Asset</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>

          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgFAMAssetTable}
            refreshCounter={0}
          />
        </TabPanel>
        </Box>
      {/* ))} */}
    </>
  );
}
